import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/filetype-xlsx.svg")